import { object as vObject, pipe as vPipe, string as vString, email as vEmail, type InferOutput, nonEmpty as vNonEmpty } from 'valibot';
import { PropertySearchCriteriaSchema } from '@@/shared/property/search-criteria';
import { LanguageSchema } from '@@/shared/application';

export const AlertBodySchema = vObject({
  email: vPipe(
    vString(),
    vNonEmpty('core.form.error.mandatory_field'),
    vEmail('agent.form.error.email'),
  ),
  propertySearchCriteria: PropertySearchCriteriaSchema,
  formattedSearchCriteria: vString(),
  locale: LanguageSchema,
});
export type AlertBody = InferOutput<typeof AlertBodySchema>;
export type AlertForm = Omit<AlertBody, 'locale'>;
